import React, { useState } from 'react';
import { TriangleBlueIcon } from './icons/TriangleBlueIcon.jsx';

const blockStyle = {
  border: '1px solid #DFE2E5',
  borderRadius: '3px',
  paddingBottom: '4px',
  paddingRight: '4px',
};

const CollapsedFormWrapper = ({
  entities,
  component,
  limit,
  duplicateBtnLimit,
  customStyles,
}) => {
  const [hidden, setHidden] = useState(true);

  return (
    <div style={{ ...blockStyle, ...customStyles }}>
      {entities.length > duplicateBtnLimit && !hidden ? (
        <button
          type="button"
          className="btn-clear bg-transparent btn-link flex"
          onClick={() => setHidden(!hidden)}
          style={{ padding: '8px 4px 6px 8px' }}
        >
          <span className="m-r-8">{hidden ? 'Show More' : 'Show Less'}</span>
          <TriangleBlueIcon
            style={{ height: '20px' }}
            transform={`rotate(${hidden ? '180' : '0'})`}
          />
        </button>
      ) : null}
      <div className="flex flex-align-start flex-wrap">
        {entities.slice(0, !hidden ? entities.length : limit).map(component)}
      </div>
      {entities.length > limit ? (
        <button
          type="button"
          className="btn-clear bg-transparent btn-link flex"
          onClick={() => setHidden(!hidden)}
          style={{ padding: '8px 4px 0 8px' }}
        >
          <span className="m-r-8">{hidden ? 'Show More' : 'Show Less'}</span>
          <TriangleBlueIcon
            style={{ height: '20px' }}
            transform={`rotate(${hidden ? '180' : '0'})`}
          />
        </button>
      ) : null}
    </div>
  );
};

export default CollapsedFormWrapper;
